import ErrorOverlay from 'components/ErrorOverlay'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styles from './EmptyContentView.pcss'

export type ContentGridView = 'stock-image'
  | 'library-image'
  | 'stock-video'
  | 'library-video'
  | 'photo-favorites'
  | 'text-favorites'
  | 'quotes'
  | 'statuses'
interface EmptyContentViewProps {
  contentView: ContentGridView
  className?: string
}

export function EmptyContentView(props: EmptyContentViewProps) {
  const intl = useIntl()
  const messages = useMemo(() => {
    return {
      'stock-image': intl.formatMessage({ id: 'search.label.no-stock-results' }),
      'library-image': intl.formatMessage({ id: 'uploads.error.empty-view-carousel-title' }),
      'stock-video': intl.formatMessage({ id: 'search.label.no-stock-results' }),
      'library-video': intl.formatMessage({ id: 'uploads.error.empty-view-carousel-title' }),
      'photo-favorites': intl.formatMessage(
        { id: 'content.msg.carousel.favorites-empty' },
        { contentType: intl.formatMessage({ id: 'general.content.filters.photos' }) }
      ),
      'text-favorites': intl.formatMessage(
        { id: 'content.msg.carousel.favorites-empty' },
        { contentType: intl.formatMessage({ id: 'content-studio.filters.text-favorites' }) }
      ),
      quotes: intl.formatMessage({ id: 'content.msg.status-ideas-search-empty' }),
      statuses: intl.formatMessage({ id: 'content.msg.status-ideas-search-empty' })
    }
  }, [intl])

  return (
    <div className={`${styles['empty-container']} ${props.className || ''}`}>
      <ErrorOverlay
        error={messages[props.contentView]}
        subtitle=""
        originalError="empty content view"
        className={styles['error-box']}
      />
    </div>
  )
}

export default EmptyContentView
